import React from "react";
import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { useT } from "@/lib/i18n";

const EASE = [0.22, 1, 0.36, 1];

export default function Manifesto() {
    const { t } = useT();
    const chapters = t("manifesto.chapters") || [];
    return (
        <section
            id="manifesto"
            data-testid={TID.manifesto.root}
            className="bg-sn-paper py-24 md:py-40"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="flex items-baseline gap-4 mb-20 md:mb-32"
                >
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-blue">
                        {t("manifesto.eyebrow")}
                    </span>
                    <span className="hairline flex-1" />
                    <span className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-ink-2">
                        {t("manifesto.count")}
                    </span>
                </motion.div>

                <div className="space-y-24 md:space-y-32">
                    {chapters.map((c, i) => {
                        const n = String(i + 1).padStart(2, "0");
                        return (
                            <motion.article
                                key={i}
                                data-testid={TID.manifesto.chapter(n)}
                                initial={{ opacity: 0, y: 60 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.35 }}
                                transition={{ duration: 1, delay: 0.05, ease: EASE }}
                                className="grid grid-cols-12 gap-6 md:gap-10 items-start"
                            >
                                <div className="col-span-12 md:col-span-3">
                                    <motion.div
                                        initial={{ opacity: 0, x: -10 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.9, delay: 0.1 }}
                                        className="font-mono-e text-[11px] uppercase tracking-[0.3em] text-sn-ink-2 mb-3"
                                    >
                                        {t("manifesto.chapterLabel")} {n}
                                    </motion.div>
                                    <div className="font-serif text-7xl md:text-8xl text-sn-blue leading-none">
                                        {n}
                                    </div>
                                </div>
                                <div className="col-span-12 md:col-span-9 md:pl-10 md:border-l md:border-black/10">
                                    <h3 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-sn-ink">
                                        {c.title}
                                        <span className="text-sn-blue">.</span>
                                    </h3>
                                    <p className="mt-6 max-w-2xl text-lg md:text-xl leading-relaxed text-sn-ink-2">
                                        {c.text}
                                    </p>
                                </div>
                            </motion.article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
